<template>
	<div class="view">
		<div class="top">
			<div class="filter">
				<div
					:class="{ selected: filter === 'articles' }"
					@click="filter = 'articles'"
				>
					Статьи
				</div>
				<div :class="{ selected: filter === 'cats' }" @click="filter = 'cats'">
					Категории
				</div>
			</div>
			<uiButton class="new" color="accent" @click="addNew" :loading="loading"
				>+ Статья</uiButton
			>
		</div>

		<template v-if="filter === 'articles'">
			<div class="articles" v-if="articles">
				<div class="cat" v-for="cat in categories" :key="cat.id">
					<div class="title">{{ cat.title }}</div>
					<draggable
						class="rows"
						:class="{ disabled: loading }"
						ghost-class="ghost"
						handle=".item"
						:forceFallback="true"
						:list="catArticles(cat)"
						@change="onSort(cat, $event)"
					>
						<div
							class="row"
							v-for="(a, index) in catArticles(cat)"
							:key="a.id"
						>
							<uiCard class="item" @click="open(a)">
								{{ a.title }}
							</uiCard>
							<div class="remove" @click="removeArticle(cat, index)">
								<i class="lni lni-trash" />
							</div>
						</div>
					</draggable>
					<uiDropdown
						:options="optionsForCat(cat)"
						label="Добавить статью"
						optionsLabel="title"
						:value="''"
						@input="addArticle(cat, $event)"
					/>
				</div>
			</div>

			<uiDevider v-if="noCatArticles.length" />

			<div class="articles" v-if="noCatArticles.length">
				<div class="title">Статьи без категории</div>
				<div class="row" v-for="a in noCatArticles" :key="a.id">
					<uiCard class="item" @click="open(a)">
						{{ a.title }}
					</uiCard>
				</div>
			</div>
		</template>

		<template v-else>
			<draggable
				class="rows"
				:class="{ disabled: loading }"
				ghost-class="ghost"
				handle=".item"
				:forceFallback="true"
				v-model="categories"
			>
				<div class="row" v-for="cat in categories" :key="cat.id">
					<uiCard class="item">
						{{ cat.title }}
					</uiCard>
					<!-- <div class="remove" @click="removeCat(cat)">
						<i class="lni lni-trash" />
					</div> -->
				</div>
			</draggable>
		</template>

		<div class="dumb" />
	</div>
</template>

<script>
import Draggable from 'vuedraggable'
import { API } from '@/config'

export default {
	name: 'ArticlesPage',
	components: {
		Draggable,
	},
	data() {
		return {
			loading: false,
			search: '',
			filter: 'articles',
		}
	},
	computed: {
		articles() {
			return this.$store.getters.articles
		},
		categories: {
			get() {
				return this.$store.getters.categories
			},
			set(nv) {
				this.$store.commit('setArray', { path: 'categories', data: nv })
				this.sortCats(nv)
			},
		},
		noCatArticles() {
			let haveCat = this.categories.reduce((prev, cur) => {
				return [...prev, ...cur.articles]
			}, [])
			return this.articles.filter((a) => !haveCat.includes(a.id))
		},
	},
	methods: {
		onSort(cat, e) {
			if (!e.moved) return
			let a = cat.articles.splice(e.moved.oldIndex, 1)[0]
			cat.articles.splice(e.moved.newIndex, 0, a)
			this.saveCat(cat)
		},
		async saveCat(cat) {
			if (this.loading) return
			this.loading = true

			let { data } = await this.$http.post(API.ARTICLES.updateCat, cat)
			if (!data || data.err) {
				this.$notify(data.err)
				this.loading = false
				return
			}

			this.$store.commit('updateInArray', { path: 'categoreis', data: data })
			this.loading = false
		},
		async removeCat(cat) {},
		async sortCats(cats) {
			if (this.loading) return
			this.loading = true

			let payload = cats.map((cat, i) => {
				cat.sortIndex = i
				return cat
			})
			let { data } = await this.$http.post(API.ARTICLES.sortCat, payload)
			if (!data || data.err) {
				this.$notify(data.err)
				this.loading = false
				return
			}

			// this.$store.commit('setArray', { path: 'categories', data: data })
			this.loading = false
		},
		catArticles(cat) {
			return cat.articles.map((id) => this.articles.find((a) => a.id === id))
		},
		optionsForCat(cat) {
			return this.articles.filter((a) => !cat.articles.includes(a.id))
		},
		addArticle(cat, e) {
			cat.articles.push(e.id)
			this.saveCat(cat)
		},
		removeArticle(cat, index) {
			cat.articles.splice(index, 1)
			this.saveCat(cat)
		},
		open(a) {
			this.$router.push('/articles/' + a.id)
		},
		addNew() {
			if (this.filter === 'articles') this.open({ id: 'new' })
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.view {
	width: 440px;
	margin-left: auto;
	margin-right: auto;
}

.top {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 20px 0;

	.filter {
		display: flex;

		div {
			color: @accent;
			padding-right: 20px;
			opacity: 0.5;
			cursor: pointer;

			&.selected {
				opacity: 1;
			}
		}
	}

	.new {
		width: 140px;
	}
}

.search {
	width: 40%;

	/deep/ input {
		height: 40px;
		border-radius: 20px;
		text-align: center;
	}
}

.articles {
	.cat {
		margin-bottom: 30px;
	}
	.title {
		margin-bottom: 10px;
		font-size: 20px;
		font-weight: bold;
		opacity: 0.3;
	}
}

.rows.disabled {
	pointer-events: none;
}

.row {
	position: relative;

	.item {
		cursor: pointer;
		margin-bottom: 15px;
		flex-shrink: 0;
		padding: 16px !important;
		font-weight: bold;
	}

	.remove {
		position: absolute;
		top: 0;
		right: -50px;
		width: 50px;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 24px;
		opacity: 0.3;
		cursor: pointer;

		&:hover {
			opacity: 1;
		}
	}
}

.dumb {
	width: 100%;
	height: 100px;
}
</style>
